// extracted by mini-css-extract-plugin
module.exports = {"messages-box":"MessagesBox_messages-box__4TxGZ","dark":"MessagesBox_dark__VGbse","light":"MessagesBox_light__3yMUY"};